"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetShops;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = require("react");

function useGetShops(shops) {
  return (0, _react.useMemo)(function () {
    var shopWithFilteredPayoutMethods = shops.map(function (shop) {
      if (!!shop['payoutMethods'].length) {
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, shop), {}, {
          payoutMethods: shop['payoutMethods'].filter(function (method) {
            return method['name'] !== 'Transfer';
          })
        });
      }

      return shop;
    });
    return shopWithFilteredPayoutMethods.filter(function (item) {
      return !!item['payoutMethods'].length;
    });
  }, [shops]);
}